import { call, put } from "redux-saga/effects";
import * as Api from "../../api";
import * as actions from "../actions";

export function* markDocumentReadThanetCouncil({ payload }) {
  yield put(actions.setThanetCouncilReadingLoading(true));
  try {
    yield call(Api.markDocumentRead, {
      document_read: payload,
      thanetCouncil: true,
    });
    yield put(actions.setThanetCouncilReadingLoading(false));
  } catch (error) {
    yield put(actions.addError("Reading List Thanet Council", error));
    yield put(actions.setThanetCouncilReadingLoading(false));
  }
}

export function* postRiskAssessmentThanetCouncilSaga({ payload }) {
  try {
    yield put(
      actions.setThanetCouncilRiskAssessmentLoading(
        Object.keys(payload.formContent)[0]
      )
    );
    const { formName, formContent } = payload;
    yield call(Api.postThanetCouncilForms, formName, formContent);
    yield put(actions.setThanetCouncilRiskAssessmentLoading(""));
  } catch (error) {
    yield put(actions.addError("post-risk-assessment-thanet-council", error));
    yield put(actions.setThanetCouncilRiskAssessmentLoading(""));
  }
}

export function* postThanetCouncilFormsSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    yield call(Api.postThanetCouncilForms, formName, formContent);
  } catch (error) {
    yield put(actions.addError("post-thanet-council-form", error));
  }
}

export function* submitThanetCouncilFormsSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    yield call(Api.submitThanetCouncilForms, formName, formContent);
  } catch (error) {
    yield put(actions.addError("submit-thanet-council-form", error));
  }
}
